/**
 * 提单错误码弹窗配置
 * - messageKey: letter 文案 key
 * - buttons: 交互按钮（最多 2 个；1 个为 tips 单按钮，2 个为取消+确认）
 * - action: 点击后执行的操作，见 SUBMIT_ERROR_ACTION
 * - tipKey: SHOW_TIP 时展示的二次提示文案
 *
 * 扩展方式：在 SUBMIT_ERROR_CONFIG 增加错误码即可，并在多语言包补充对应 key
 */

export const SUBMIT_ERROR_ACTION = {
  CLOSE: 'close',
  GO_HOME: 'goHome',
  BACK_PRODUCT_LIST: 'backProductList',
  CLEAR_CART_BACK_PRODUCT: 'clearCartBackProduct',
  OPEN_ORDER_QUERY: 'openOrderQuery',
  RETRY_PAY: 'retryPay',
  RELOAD: 'reload',
  SHOW_LOGIN: 'showLogin',
  SWITCH_PAY_TYPE: 'switchPayType',
  CONTACT_SERVICE: 'contactService',
  SHOW_SELECT_ROLE: 'showSelectRole',
  SHOW_TIP: 'showTip',
  OPEN_WORK_FORM: 'openWorkForm'
};

/** 通用按钮文案 key */
export const SUBMIT_ERROR_BTN = {
  CONFIRM: 'v3Confirm',
  VIEW_ORDER: 'v3SubmitErrBtnViewOrder',
  BACK_HOME: 'v3SubmitErrBtnBackHome',
  RETRY: 'v3SubmitErrBtnRetry',
  RELOGIN: 'v3SubmitErrBtnRelogin',
  SWITCH_PAY: 'v3SubmitErrBtnSwitchPay',
  REORDER: 'v3SubmitErrBtnReorder',
  CONTACT_SERVICE: 'v3ContactCustomerService',
  SWITCH_SERVER: 'v3SubmitErrBtnSwitchServer',
  VIEW_ORDER_STATUS: 'v3SubmitErrBtnViewOrderStatus',
  BACK_STORE: 'v3SubmitErrBtnBackStore',
  GO_UPDATE: 'v3SubmitErrBtnGoUpdate',
  RESUBSCRIBE: 'v3SubmitErrBtnResubscribe'
};

const msg = code => `v3SubmitErrMsg${code}`;

/**
 * @typedef {Object} SubmitErrorButton
 * @property {string} textKey
 * @property {string} action
 * @property {string} [tipKey]
 */

/**
 * @typedef {Object} SubmitErrorItem
 * @property {string} messageKey
 * @property {SubmitErrorButton[]} buttons
 */

/** @type {Record<string|number, SubmitErrorItem>} */
export const SUBMIT_ERROR_CONFIG = {
  // 对接完成
  120009: {
    messageKey: msg(120009),
    buttons: [
      { textKey: SUBMIT_ERROR_BTN.CONFIRM, action: SUBMIT_ERROR_ACTION.GO_HOME },
      {
        textKey: SUBMIT_ERROR_BTN.VIEW_ORDER,
        action: SUBMIT_ERROR_ACTION.OPEN_ORDER_QUERY
      }
    ]
  },
  // 对接完成
  120003: {
    messageKey: msg(120003),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.BACK_HOME,
        action: SUBMIT_ERROR_ACTION.BACK_PRODUCT_LIST
      }
    ]
  },
  // 对接完成
  120016: {
    messageKey: msg(120016),
    buttons: [
      { textKey: SUBMIT_ERROR_BTN.RETRY, action: SUBMIT_ERROR_ACTION.RETRY_PAY }
    ]
  },
  // 对接完成
  120025: {
    messageKey: msg(120025),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.RELOGIN,
        action: SUBMIT_ERROR_ACTION.SHOW_LOGIN
      }
    ]
  },
  // 对接完成
  121012: {
    messageKey: msg(121012),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.SWITCH_PAY,
        action: SUBMIT_ERROR_ACTION.SWITCH_PAY_TYPE
      }
    ]
  },
  // 对接完成
  120012: {
    messageKey: msg(120012),
    buttons: [
      { textKey: SUBMIT_ERROR_BTN.RETRY, action: SUBMIT_ERROR_ACTION.RELOAD }
    ]
  },
  // 对接完成
  120002: {
    messageKey: msg(120002),
    buttons: [
      { textKey: SUBMIT_ERROR_BTN.CONFIRM, action: SUBMIT_ERROR_ACTION.GO_HOME }
    ]
  },
  // 对接完成
  121019: {
    messageKey: msg(121019),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.REORDER,
        action: SUBMIT_ERROR_ACTION.CLEAR_CART_BACK_PRODUCT
      }
    ]
  },
  // 对接完成
  120024: {
    messageKey: msg(120024),
    buttons: [
      { textKey: SUBMIT_ERROR_BTN.CONFIRM, action: SUBMIT_ERROR_ACTION.CLOSE }
    ]
  },
  // 对接完成
  120000: {
    messageKey: msg(120000),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.RELOGIN,
        action: SUBMIT_ERROR_ACTION.SHOW_LOGIN
      }
    ]
  },
  // 对接完成
  120014: {
    messageKey: msg(120014),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.REORDER,
        action: SUBMIT_ERROR_ACTION.CLEAR_CART_BACK_PRODUCT
      }
    ]
  },
  // 对接完成
  120015: {
    messageKey: msg(120015),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.CONFIRM,
        action: SUBMIT_ERROR_ACTION.CLEAR_CART_BACK_PRODUCT
      }
    ]
  },
  // 对接完成
  120001: {
    messageKey: msg(120001),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.SWITCH_SERVER,
        action: SUBMIT_ERROR_ACTION.SHOW_SELECT_ROLE
      }
    ]
  },
  // 对接完成, 
  // 改为了关闭弹窗，让玩家手动选择渠道
  120020: {
    messageKey: msg(120020),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.SWITCH_PAY,
        action: SUBMIT_ERROR_ACTION.CLOSE
      }
    ]
  },
  // 对接完成
  120010: {
    messageKey: msg(120010),
    buttons: [
      { textKey: SUBMIT_ERROR_BTN.CONFIRM, action: SUBMIT_ERROR_ACTION.GO_HOME }
    ]
  },
  // 对接完成
  120006: {
    messageKey: msg(120006),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.CONFIRM,
        action: SUBMIT_ERROR_ACTION.CLEAR_CART_BACK_PRODUCT
      }
    ]
  },
  // 对接完成
  121010: {
    messageKey: msg(121010),
    buttons: [
      { textKey: SUBMIT_ERROR_BTN.CONFIRM, action: SUBMIT_ERROR_ACTION.CLOSE }
    ]
  },
  // 对接完成
  120017: {
    messageKey: msg(120017),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.VIEW_ORDER_STATUS,
        action: SUBMIT_ERROR_ACTION.OPEN_ORDER_QUERY
      }
    ]
  },
  // 对接完成
  120022: {
    messageKey: msg(120022),
    buttons: [
      { textKey: SUBMIT_ERROR_BTN.RETRY, action: SUBMIT_ERROR_ACTION.CLOSE }
    ]
  },
  // 对接完成
  121000: {
    messageKey: msg(121000),
    buttons: [
      { textKey: SUBMIT_ERROR_BTN.CONFIRM, action: SUBMIT_ERROR_ACTION.CLOSE }
    ]
  },
  // 对接完成
  120011: {
    messageKey: msg(120011),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.BACK_HOME,
        action: SUBMIT_ERROR_ACTION.BACK_PRODUCT_LIST
      }
    ]
  },
  // 对接完成
  121015: {
    messageKey: msg(121015),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.BACK_HOME,
        action: SUBMIT_ERROR_ACTION.CLEAR_CART_BACK_PRODUCT
      }
    ]
  },
  // 对接完成
  120004: {
    messageKey: msg(120004),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.SWITCH_PAY,
        action: SUBMIT_ERROR_ACTION.SWITCH_PAY_TYPE
      }
    ]
  },
  // 对接完成
  120005: {
    messageKey: msg(120005),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.SWITCH_PAY,
        action: SUBMIT_ERROR_ACTION.SWITCH_PAY_TYPE
      }
    ]
  },
  // 对接完成
  120007: {
    messageKey: msg(120007),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.RELOGIN,
        action: SUBMIT_ERROR_ACTION.SHOW_LOGIN
      }
    ]
  },
  // 对接完成
  120008: {
    messageKey: msg(120008),
    buttons: [
      { textKey: SUBMIT_ERROR_BTN.RETRY, action: SUBMIT_ERROR_ACTION.GO_HOME }
    ]
  },
  // 对接完成
  120013: {
    messageKey: msg(120013),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.REORDER,
        action: SUBMIT_ERROR_ACTION.CLEAR_CART_BACK_PRODUCT
      }
    ]
  },
  // 对接完成
  120018: {
    messageKey: msg(120018),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.CONFIRM,
        action: SUBMIT_ERROR_ACTION.CLOSE
      }
    ]
  },
  // 对接完成
  120019: {
    messageKey: msg(120019),
    buttons: [
      { textKey: SUBMIT_ERROR_BTN.CONFIRM, action: SUBMIT_ERROR_ACTION.CLOSE }
    ]
  },
  // 对接完成
  120021: {
    messageKey: msg(120021),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.BACK_STORE,
        action: SUBMIT_ERROR_ACTION.BACK_PRODUCT_LIST
      }
    ]
  },
  // 对接完成
  120023: {
    messageKey: msg(120023),
    buttons: [
      { textKey: SUBMIT_ERROR_BTN.CONFIRM, action: SUBMIT_ERROR_ACTION.CLOSE }
    ]
  },
  // 对接完成
  120026: {
    messageKey: msg(120026),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.RELOGIN,
        action: SUBMIT_ERROR_ACTION.SHOW_LOGIN
      }
    ]
  },
  // 对接完成
  120030: {
    messageKey: msg(120030),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.BACK_STORE,
        action: SUBMIT_ERROR_ACTION.BACK_PRODUCT_LIST
      }
    ]
  },
  // 对接完成
  120031: {
    messageKey: msg(120031),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.BACK_STORE,
        action: SUBMIT_ERROR_ACTION.BACK_PRODUCT_LIST
      }
    ]
  },
  // 对接完成
  120032: {
    messageKey: msg(120032),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.GO_UPDATE,
        action: SUBMIT_ERROR_ACTION.SHOW_TIP,
        tipKey: 'v3SubmitErrTipUpdateApp'
      }
    ]
  },
  // 对接完成
  // 改为了关闭弹窗，让玩家手动选择渠道
  120080: {
    messageKey: msg(120080),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.SWITCH_PAY,
        action: SUBMIT_ERROR_ACTION.CLOSE
      }
    ]
  },
  // 对接完成
  120081: {
    messageKey: msg(120081),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.VIEW_ORDER_STATUS,
        action: SUBMIT_ERROR_ACTION.OPEN_ORDER_QUERY
      }
    ]
  },
  // 对接完成
  121002: {
    messageKey: msg(121002),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.REORDER,
        action: SUBMIT_ERROR_ACTION.CLEAR_CART_BACK_PRODUCT
      }
    ]
  },
  // 对接完成
  121004: {
    messageKey: msg(121004),
    buttons: [
      { textKey: SUBMIT_ERROR_BTN.RETRY, action: SUBMIT_ERROR_ACTION.RETRY_PAY }
    ]
  },
  // 对接完成
  121005: {
    messageKey: msg(121005),
    buttons: [
      { textKey: SUBMIT_ERROR_BTN.RETRY, action: SUBMIT_ERROR_ACTION.RETRY_PAY }
    ]
  },
  // 对接完成
  121006: {
    messageKey: msg(121006),
    buttons: [
      { textKey: SUBMIT_ERROR_BTN.RETRY, action: SUBMIT_ERROR_ACTION.RETRY_PAY }
    ]
  },
  // 对接完成
  121011: {
    messageKey: msg(121011),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.GO_UPDATE,
        action: SUBMIT_ERROR_ACTION.SHOW_TIP,
        tipKey: 'v3SubmitErrTipUpdateApp'
      }
    ]
  },
  // 对接完成
  121013: {
    messageKey: msg(121013),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.REORDER,
        action: SUBMIT_ERROR_ACTION.CLEAR_CART_BACK_PRODUCT
      }
    ]
  },
  // 对接完成
  121014: {
    messageKey: msg(121014),
    buttons: [
      { textKey: SUBMIT_ERROR_BTN.RETRY, action: SUBMIT_ERROR_ACTION.RETRY_PAY }
    ]
  },
  // 对接完成
  121020: {
    messageKey: msg(121020),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.REORDER,
        action: SUBMIT_ERROR_ACTION.CLEAR_CART_BACK_PRODUCT
      }
    ]
  },
  // 对接完成
  121021: {
    messageKey: msg(121021),
    buttons: [
      { textKey: SUBMIT_ERROR_BTN.RETRY, action: SUBMIT_ERROR_ACTION.RETRY_PAY }
    ]
  },
  // 对接完成
  121022: {
    messageKey: msg(121022),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.RELOGIN,
        action: SUBMIT_ERROR_ACTION.SHOW_LOGIN
      }
    ]
  },
  // 对接完成
  121023: {
    messageKey: msg(121023),
    buttons: [
      {
        textKey: SUBMIT_ERROR_BTN.VIEW_ORDER_STATUS,
        action: SUBMIT_ERROR_ACTION.OPEN_ORDER_QUERY
      }
    ]
  },
  // 对接完成
  121024: {
    messageKey: msg(121024),
    buttons: [
      { textKey: SUBMIT_ERROR_BTN.RETRY, action: SUBMIT_ERROR_ACTION.RETRY_PAY }
    ]
  }
};

export const SUBMIT_ERROR_DEFAULT_CONFIG = {
  useApiMessage: true,
  buttons: [
    { textKey: SUBMIT_ERROR_BTN.CONFIRM, action: SUBMIT_ERROR_ACTION.CLOSE }
  ]
};

export function getSubmitErrorConfig(code) {
  if (code === undefined || code === null || code === '') {
    return SUBMIT_ERROR_DEFAULT_CONFIG;
  }
  return SUBMIT_ERROR_CONFIG[+code] || SUBMIT_ERROR_DEFAULT_CONFIG;
}

/**
 * 是否为 SUBMIT_ERROR_CONFIG 中已配置的错误码（需打点）
 * @param {string|number} [code]
 */
export function isConfiguredSubmitErrorCode(code) {
  if (code === undefined || code === null || code === '') {
    return false;
  }
  return Object.prototype.hasOwnProperty.call(SUBMIT_ERROR_CONFIG, +code);
}
